import { sync } from 'vuex-pathify'
// définir un objet mixin

export const blueyetiStates = {
  data() {
    return {
      byStates : {},
      byst_enabled: true,
      byst_is_active: false,
      byst_active_states: [],
      byst_active_all_states: false,
      byst_active_except: []
    }
  },
  computed: {
    byst_app_state: sync('app_state')
},
  created: function () {
    console.log('hello from mixin!')
  },
  mounted () {
  },
  watch: {
    // watch byst_app_state and set byst_is_active
    byst_app_state: {
      immediate: true, // watch at startup too
      handler(newVal, oldVal) {
        //console.log("byst_app_state newvalue " + newVal + " oldValue " + oldVal);
        this.byst_TestIsActive(newVal);
      }
    }
  },
  methods: {
    // set state
    byst_SetState: function (newState) {
      this.byst_app_state = newState;
      console.log('byst_SetState new state : ' + newState);
    },
    // set state, and prevent event if need
    byst_SetState_prevent: function (newState, event) {
      if (event) event.preventDefault()
      this.byst_app_state = newState;
      console.log('byst_SetState_prevent : new state : ' + newState);
    },
    byst_CompareCurrentStates: function (states)
    {
      //console.log('byst_CompareCurrentStates ' + this.byst_CompareStates(this.byst_app_state, states));

      return this.byst_CompareStates(this.byst_app_state, states);
    },
    byst_TestIsActive: function (val)
    {
      if (!this.byst_enabled)
          return;

      if (!this.byst_active_all_states && this.byst_active_states.length == 0 && this.byst_active_except.length == 0)
      {
        this.byst_is_active = false;
        return;
      }

      if (this.byst_active_all_states)
      {

          if (this.byst_active_except.length != 0
               && this.byst_CompareStates(val, this.byst_active_except))
          { //if autoTransitionIn = false, transition out until initDone
            // exit: current state is in an unactive state
              //StartTransitionOut();
              this.byst_is_active = false;

          }
          else
          {
              // enter
              //StartTransitionIn();
              this.byst_is_active = true;

          }
      }
      else
      {
        //console.log("before compare states");
          // the current state is an active state
          // enter state
          var CStates = this.byst_CompareStates(val, this.byst_active_states);
          if (CStates) // && autoTransitionIn)
          {
              //StartTransitionIn();
              this.byst_is_active = true;
              //console.log("byst_is_active value " + this.byst_is_active);
          }
          else if (!CStates) // || (!autoTransitionIn && !initDone))
          {
              // the current state is not an active state
              //StartTransitionOut();
              this.byst_is_active = false;
          }
      }

  },
    // split state, recursive comparison
    byst_CompareStates: function (currentState, states)
 {
     var splitCurrState = currentState.split("/");
     var splitCurrStateLength = splitCurrState.length;

     // //console.log("in compare states, states.length " + states.length);
     // var statesList = [];
     //  if (typeof states === 'string') {
     //    statesList.push(states);
     //    console.log("string " + statesList);
     //  }
     //  else
     //   statesList = states;

    for (var j = 0; j < states.length; j++)
     {
       var st = states[j];
       //console.log("in compare states " + st + " index " + i);

         var splitSt = st.split("/");
         var splitStLength = splitSt.length;
         //if (gameObject.name == "KeyNumberButton_11") Debug.Log("ici " + currentState + " et " + st);

         if (splitCurrStateLength + 1 < splitStLength ||
             (splitCurrStateLength + 1 == splitStLength
                 && splitSt[splitStLength - 1] != "*") ||
             (splitCurrStateLength > splitStLength && splitSt[splitStLength - 1] != "*"))
         {
             // go to next state because the length is different and there is no wild card
             // thus no possibility that the two string array are equal
             continue;
         }
         // for default state (ex: current state = A/B and the state array contains A/B/*)

         if (splitCurrStateLength + 1 == splitStLength
             && splitSt[splitStLength - 1] == "*")
         {
             for (var i = 0; i < splitStLength - 1; i++)
             {
                 var split_i = splitSt[i];
                 if (split_i != splitCurrState[i])
                 {
                     break;
                 }
                 else if (i == splitCurrStateLength - 1)
                 {
                     return true;
                 }
             }
         }

         for (var i = 0; i < splitCurrStateLength; i++)
         {

             var split_i = splitSt[i];
             if (split_i == "*")
             {
                 // finish -> state accepted
                 return true;
             }

             if (split_i != splitCurrState[i])
             {
                 // compare next state in state array
                 break;
             }
             else if (i == splitCurrStateLength - 1)
             {
                 // Current state  = st

                 return true;
             }
         }
     }

     return false;
 }


  }
}
